<div class="week-selector-container">
  <mat-card class="week-selector-card" [class]="'season-' + getCurrentWeekInfo().season">
    <div class="season-background"></div>
    
    <div class="selector-header">
      <div class="season-info">
        <mat-icon class="season-icon">{{ getSeasonIcon(getCurrentWeekInfo().season) }}</mat-icon>
        <div class="season-details">
          <h3 class="season-name">{{ getSeasonName(getCurrentWeekInfo().season) }}</h3>
          <p class="year-label">{{ currentYear }}</p>
        </div>
      </div>
      
      <div class="week-info">
        <div class="week-number">{{ currentWeek }}. hét</div>
        <div class="week-dates">
          {{ formatDate(getCurrentWeekInfo().startDate) }} - {{ formatDate(getCurrentWeekInfo().endDate) }}
        </div>
      </div>

      @if (showExport) {
        <button mat-icon-button
                type="button"
                class="export-button"
                [disabled]="exportDisabled || isExporting"
                matTooltip="Exportálás XLSX-be"
                aria-label="Exportálás XLSX-be"
                (click)="onExportClick()">
          <mat-icon>download</mat-icon>
        </button>
      }
    </div>

    <div class="slider-container">
      <div class="slider-wrapper">
        <mat-slider 
          #weekSlider
          [min]="1" 
          [max]="maxWeeks" 
          [step]="1"
          [discrete]="true"
          (mouseup)="removeFocus($event)"
          (touchend)="removeFocus($event)"
          class="week-slider">
          <input matSliderThumb [value]="currentWeek" (input)="onSliderInput($event)">
        </mat-slider>
      </div>
    </div>
  </mat-card>
</div>
